import { Api } from '../../../api';
import TicketBadge from './TicketBadge';

type Props = Readonly<{
  label: Api.TicketLabel.BaseView;
}>;

export default function LabelBox({ label }: Props) {
  return (
    <TicketBadge
      label={label.name}
      color={label.color ? `#${label.color}` : undefined}
      bordered
    />
  );
}
